var lib_core = require("lib-core");

var MovingModel = require("./../moving/movingModel.js");

var HandlesModel = function (editorModel) {
    MovingModel.apply(this, arguments);

    this.movingCollection = new lib_core.Collections.HashSet();
    this.activeHandle = null;
};
lib_core.inherit(HandlesModel, MovingModel);
lib_core.JsonParser.registerClass(HandlesModel, "HandlesModel");

module.exports = HandlesModel;

HandlesModel.prototype.getMoveCollection = function() {
    return this.movingCollection;
};

HandlesModel.prototype.getMoveHandle = function() {
};

HandlesModel.prototype.getMoveSubHandle = function() {
};
